// action-button.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, BaseButtonComponent],
  selector: 'app-payment-loyalty-button',
  template: `
    <app-base-button
      [baseClass]="'w-full rounded-2xl h-20'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex flex-col w-full">
        <div class="h-10 bg-theme-primary rounded-t-2xl border border-theme-primary text-theme-contrast">
          <div class="flex flex-row text-base items-center h-10 px-4 gap-2">
            <i *ngIf="icon1" class="fas" [class]="icon1"></i>
            <div class="font-bold line-clamp-1 text-start break-all">{{title1}}</div>
            <div class="ml-auto flex flex-row gap-2"><i *ngIf="icon2" class="fas" [class]="icon2"></i><div *ngIf="title2" class="text-sm font-bold whitespace-nowrap">{{title2}}</div></div>
          </div>
        </div>
        <div class="flex flex-row items-center h-10 border border-theme-primary-light rounded-b-2xl">
          <div *ngIf="subTitle1" class="line-clamp-1 break-all flex-1 text font-bold text-theme-primary px-4 text-start text-sm">{{ subTitle1 }}</div>
          <div *ngIf="subTitle2" class="font-bold text-theme-primary px-4 text-end text-sm whitespace-nowrap">{{ subTitle2 }}</div>
        </div>
      </div>
    </app-base-button>
  `
})
export class PaymentLoyaltyButtonComponent {
  @Input() title1: string | undefined = undefined;
  @Input() title2: string | undefined = undefined;
  @Input() subTitle1: string | undefined = undefined;
  @Input() subTitle2: string | undefined = undefined;
  @Input() icon1: string | undefined = undefined;
  @Input() icon2: string | undefined = undefined;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
  @Input() itemCount: number = 0;
  @Input() spinner!: boolean;
}
